/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationcolumnactions2Inputs */

const en_moderationcolumnactions2 = /** @type {(inputs: Moderationcolumnactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const de_moderationcolumnactions2 = /** @type {(inputs: Moderationcolumnactions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Moderationcolumnactions2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationcolumnactions2 = /** @type {((inputs?: Moderationcolumnactions2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationcolumnactions2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationcolumnactions2(inputs)
	return de_moderationcolumnactions2(inputs)
});
export { moderationcolumnactions2 as "moderationColumnActions" }